<template>
  <a-layout class="easyEarn">
    <a-layout-header>
      <PageNav></PageNav>
    </a-layout-header>
    <a-layout-content>
      <div class="earn-body">
        <div class="banner">
          <div class="banner-content">
            <div class="_left">
              <h1>{{ $t('easy_earn.live_coin_treasure') }}</h1>
              <p>{{ $t('easy_earn.daily_interest_one_click_redemption') }}</p>
            </div>
            <div class="_right">
              <!-- 未登录状态 -->
              <div v-if="!isLogin" class="not-log">
                <svg width="50" height="50" viewBox="0 0 66 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M52.962 3.83c3.23 4.245 2.435 10.285-1.776 13.49-4.212 3.204-10.245 2.36-13.475-1.886-3.23-4.245-2.435-10.285 1.776-13.49C43.7-1.26 49.732-.415 52.962 3.83Z"
                      fill="#9C69FF"></path>
                  <path
                      d="M23.228 29.47c-4.163-5.471-3.138-13.254 2.29-17.383 5.426-4.13 13.2-3.042 17.363 2.429 4.163 5.47 3.138 13.253-2.29 17.382-5.426 4.13-13.2 3.042-17.363-2.428Z"
                      fill="#05C3DD"></path>
                  <g filter="url(#assetLogin_svg__a)">
                    <rect x="9" y="22" width="47" height="33" rx="1.82" fill="url(#assetLogin_svg__b)"
                          fill-opacity="0.5"></rect>
                    <rect x="8.75" y="21.75" width="47.5" height="33.5" rx="2.07" stroke="#393939"
                          stroke-width="0.5"></rect>
                  </g>
                  <path fill="#05C3DD" d="M47.233 35.597H58v6.63H47.233z"></path>
                  <defs>
                    <linearGradient id="assetLogin_svg__b" x1="10.152" y1="32.033" x2="15.541" y2="7.514"
                                    gradientUnits="userSpaceOnUse">
                      <stop stop-color="#B8B8B8"></stop>
                      <stop offset="1" stop-color="#393939" stop-opacity="0"></stop>
                    </linearGradient>
                    <filter id="assetLogin_svg__a" x="0.191" y="13.191" width="64.618" height="50.618"
                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                      <feGaussianBlur in="BackgroundImageFix" stdDeviation="4.154"></feGaussianBlur>
                      <feComposite in2="SourceAlpha" operator="in"
                                   result="effect1_backgroundBlur_2497_16220"></feComposite>
                      <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_2497_16220" result="shape"></feBlend>
                    </filter>
                  </defs>
                </svg>
                <p>{{ $t('easy_earn.login_to_view_earnings') }}</p>
                <a-button class="button" @click="goToLogin">{{ $t('easy_earn.login') }}</a-button>
              </div>
              <!-- 已登录状态 -->
              <div v-else class="login-info">
                <div class="user-balance">
                  <h3>{{ $t('easy_earn.my_live_coin_treasure') }}</h3>
                  <div class="balance-info">
                    <div class="balance-item">
                      <span class="label">{{ $t('easy_earn.total_staking') }}</span>
                      <span class="value">{{ formatNumber(totalBalance, 2) }} USDT</span>
                    </div>
                    <div class="balance-item">
                      <span class="label">{{ $t('easy_earn.today_earnings') }}</span>
                      <span class="value">{{ formatNumber(yesterdayEarnings, 2) }} USDT</span>
                    </div>
                    <div class="balance-item">
                      <span class="label">{{ $t('easy_earn.total_earnings') }}</span>
                      <span class="value">{{ formatNumber(totalEarnings, 2) }} USDT</span>
                    </div>
                  </div>
                  <div class="action-buttons">
                    <a-button type="primary" @click="openDefaultDeposit">{{ $t('easy_earn.subscribe_now') }}</a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product">
          <div class="product-content">
            <div class="head">
              <div class="title">
                <span>{{ $t('easy_earn.featured_products') }}</span>
                <span>{{ $t('easy_earn.deposit_assets_for_stable_returns') }}</span>
              </div>
            </div>
            <div class="product-list product-list--details">
              <div class="subTabs">
                <div class="item">
                  <span>{{ $t('easy_earn.currency') }}</span>
                </div>
                <div class="item">
                  <span>{{ $t('easy_earn.daily_interest') }} / {{ $t('easy_earn.annual_yield') }}</span>
                </div>
                <div class="item">
                  <span>{{ $t('easy_earn.term_days') }}</span>
                </div>
                <div class="item">
                  <span>{{ $t('investment.investment_threshold') }}</span>
                </div>
                <div class="item">
                  <span>{{ $t('easy_earn.redemption_method') }}</span>
                </div>
                <div class="item">
                  <span>{{ $t('easy_earn.operation') }}</span>
                </div>
              </div>
              <div class="content">
                <!-- 加载状态 -->
                <div v-if="loading" class="loading-state" style="text-align: center; padding: 40px;">
                  <a-spin size="large" />
                  <p style="margin-top: 10px; color: var(--content-secondary);">{{ $t('easy_earn.loading_product_data') }}</p>
                </div>
                
                <!-- 产品列表 -->
                <div v-else-if="products.length > 0" class="cell" v-for="(product, productIndex) in products" :key="product.id || productIndex">
                  <div class="item">
                    <img :src="product.icon || getCoinImage(product.symbol || product.currency_symbol || product.currency)" :alt="product.symbol || product.currency_symbol || product.currency">
                    <span>{{ product.symbol || product.currency_symbol || product.currency || 'USDT' }}</span>
                  </div>
                  <div class="item">
                    <div class="rate-info">
                      <span>{{ $t('easy_earn.daily_interest') }} {{ formatPercentage(product.day_rate || product.daily_rate || '0.00') }}</span>
                      <span>{{ $t('easy_earn.annual_yield') }} {{ formatPercentage(product.year_rate || product.annual_rate || product.rate || '0.00') }}</span>
                    </div>
                  </div>
                  <div class="item">
                    <span>{{ formatProductTerm(product) }}</span>
                  </div>
                  <div class="item">
                    <span>{{ formatProductAmountWithSymbol(product.min, product.symbol || product.currency_symbol || product.currency) }}</span>
                  </div>
                  <div class="item">
                    <span>{{ $t('easy_earn.maturity_settlement') }}</span>
                  </div>
                  <div class="item">
                    <a-button class="button" @click="openDeposit(product)">{{ $t('easy_earn.subscribe_now') }}</a-button>
                  </div>
                </div>
                
                <!-- 空状态 -->
                <div v-else class="empty-state" style="text-align: center; padding: 40px;">
                  <a-empty :description="$t('easy_earn.no_product_data')" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      立即申购弹窗-->
      <a-modal :visible="visible"
               align-center
               :render-to-body="false"
               :mask-style="{ background: 'rgba(0, 0, 0, .5)' }"
               modal-class="mode-box"
               :hide-title="true"
               :footer="false">
        <div class="modal-con">
          <div class="title-box flex align-center jus-center">
            <span class="font-24 font-bold color-white">{{ $t('easy_earn.subscription_confirmation') }}</span>
            <icon-close @click="visible = false" class="color-white font-bold pointer close-btn" size="24"/>
          </div>
          <div class="flex align-start jus-bet con-box">
            <div class="flex flex-column align-start con-left">
              <div class="cell flex align-center jus-bet">
                <span class="font-14 color-gray">{{ $t('easy_earn.subscription_product') }}</span>
                <span class="font-14 color-white">{{ selectedProduct ? (selectedProduct.symbol || selectedProduct.currency_symbol) + ' ' + $t('easy_earn.live_coin_treasure') : $t('easy_earn.live_coin_treasure') }}</span>
              </div>
              <div class="cell flex align-center jus-bet">
                <span class="font-14 color-gray">{{ $t('investment.term') }}</span>
                <span class="font-14 color-white">{{ selectedProduct ? formatProductTerm(selectedProduct) : '--' }}</span>
              </div>
              <div class="cell flex align-center jus-bet">
                <span class="font-14 color-gray">{{ $t('investment.investment_threshold') }}</span>
                <span class="font-14 color-white">{{ selectedProduct ? formatProductAmountWithSymbol(selectedProduct.min, selectedProduct.symbol || selectedProduct.currency_symbol || selectedProduct.currency) : '--' }}</span>
              </div>
              <div class="cell flex align-center jus-bet">
                <span class="font-14 color-gray">{{ $t('easy_earn.maturity_settlement') }}</span>
                <span class="font-14 color-white">{{ $t('easy_earn.maturity_settlement') }}</span>
              </div>
              <div class="cell flex align-center jus-bet">
                <span class="font-14 color-gray">{{ $t('easy_earn.daily_interest') }}</span>
                <span class="font-14 color-white">{{ selectedProduct ? formatPercentage(selectedProduct.day_rate || selectedProduct.daily_rate || '0.00') : '0.6%' }}</span>
              </div>
              <div class="cell flex align-center jus-bet">
                <span class="font-14 color-gray">{{ $t('easy_earn.annual_yield') }}</span>
                <span class="font-14 color-white">{{ selectedProduct ? formatPercentage(selectedProduct.year_rate || selectedProduct.annual_rate || '0.00') : '2.19%' }}</span>
              </div>
              <div class="cell cell-input flex flex-column align-start">
                <span class="font-14 color-gray mb-5">{{ $t('easy_earn.subscription_amount') }}</span>
                <div class="input_box mb-5">
                  <a-input 
                    id="subscription-amount"
                    name="subscriptionAmount"
                    v-model="subscriptionAmount" 
                    :placeholder="$t('easy_earn.min_subscription', { amount: selectedProduct ? formatNumber(selectedProduct.min || '1', 2) : '1' })" 
                    @input="calculateEstimatedInterest">
                    <template #suffix>
                      <div class="flex align-center jus-end">
                        <span class="font-14 color-gray">{{ selectedProduct ? selectedProduct.symbol || 'USDT' : 'USDT' }}</span>
                        <span>|</span>
                        <span class="color-primary pointer" @click="setMaxAmount">{{ $t('easy_earn.max') }}</span>
                      </div>
                    </template>
                  </a-input>
                </div>
                <span class="font-13 color-red" v-if="selectedProduct && parseFloat(subscriptionAmount) > parseFloat(selectedProduct.balance || 0)">{{ $t('easy_earn.insufficient_balance') }}</span>
              </div>
              <div class="cell flex align-center jus-bet">
                <div class="flex align-center">
                  <span class="font-14 color-gray">{{ $t('easy_earn.available_balance') }}：</span>
                  <span class="font-14 color-white">{{ selectedProduct ? formatNumber(selectedProduct.balance, 4) + ' ' + (selectedProduct.symbol || 'USDT') : '0.00 USDT' }}</span>
                </div>
                                  <span class="color-primary pointer" @click="refreshDepositBalance">{{ $t('easy_earn.refresh_balance') }}</span>
              </div>
              <div class="cell flex align-center jus-bet mt-10">
                <span class="font-14 color-white">{{ $t('easy_earn.auto_subscribe') }}</span>
                <a-switch 
                  v-model="autoDeposit" 
                  checked-color="var(--color-primary)" 
                  unchecked-color="var(--background-secondary)"
                  @change="handleAutoDepositChange">
                  <template #checked-icon>
                    <icon-check/>
                  </template>
                  <template #unchecked-icon>
                    <icon-close/>
                  </template>
                </a-switch>
              </div>
              <div class="cell flex align-center jus-bet mt-10">
                <span class="font-12 color-gray">{{ $t('easy_earn.auto_subscribe_desc') }}</span>
              </div>
            </div>
            <div class="flex flex-column align-start con-right">
              <p class="font-16 color-white">{{ $t('easy_earn.transaction_details') }}</p>
              <div class="cell flex align-center jus-bet mt-10">
                <span class="font-14 color-white">{{ $t('easy_earn.estimated_daily_interest') }}</span>
                <span class="font-14 color-white">{{ formatNumber(estimatedDailyInterest, 4) }} {{ selectedProduct ? selectedProduct.symbol || 'USDT' : 'USDT' }}</span>
              </div>
              <div class="timeline">
                <a-timeline>
                  <a-timeline-item :label="submitDate">{{ $t('easy_earn.buy_submit') }}</a-timeline-item>
                  <a-timeline-item :label="interestStartDate">{{ $t('easy_earn.interest_start_date') }}</a-timeline-item>
                </a-timeline>
              </div>
              <div class="cell flex align-center jus-bet">
                <div class="flex align-center">
                  <span class="font-14 color-gray mr-5">{{ $t('easy_earn.fixed_daily_interest') }}</span>
                  <a-tooltip background-color="#636870">
                    <icon-question-circle-fill class="color-gray pointer"/>
                    <template #content>
                      <p>{{ $t('easy_earn.interest_calculation_rules') }}：</p>
                      <p>{{ $t('easy_earn.interest_calculation_desc') }}</p>
                      <p>{{ $t('easy_earn.fixed_interest_formula') }}</p>
                      <p>{{ $t('easy_earn.tiered_interest_formula') }}</p>
                      <p>{{ $t('easy_earn.interest_rate_note') }}</p>
                    </template>
                  </a-tooltip>
                </div>
                <span class="font-14 color-green">{{ selectedProduct ? formatPercentage(selectedProduct.day_rate || '0.00') : '0.6%' }}</span>
              </div>
            </div>
          </div>

          <div class="flex align-center jus-bet btn-group">
            <a-button @click="visible = false">{{ $t('easy_earn.cancel') }}</a-button>
            <a-button @click="confirmSubscription" :loading="subscriptionLoading" :disabled="!subscriptionAmount">{{ $t('easy_earn.confirm') }}</a-button>
          </div>
        </div>
      </a-modal>
      
      <!-- 赎回功能已关闭，产品仅在期限结束后结算。 -->
    </a-layout-content>
    <a-layout-footer>
      <Footer></Footer>
    </a-layout-footer>
  </a-layout>
</template>
<script>
import Footer from "@/components/Footer/footer.vue";
import PageNav from "@/components/PageNav/PageNav.vue";
import notlog from "@/components/notlog/notlog.vue";
import { mapGetters } from 'vuex';
import depositApi from '@/common/api/deposit.js';
import commonApi from '@/common/api/common.js';

export default {
  components: {notlog, PageNav, Footer},
  data() {
    return {
      coinList: [],
      visible: false,
      // 活币宝数据
      totalBalance: "0.00",
      yesterdayEarnings: "0.00",
      totalEarnings: "0.00",
      // 产品数据
      products: [],
      loading: false,
      selectedProduct: null,
      // 申购相关数据
      subscriptionAmount: "",
      estimatedDailyInterest: "0.00",
      submitDate: "",
      interestStartDate: "",
      // 申购相关数据
      subscriptionLoading: false,
      // 自动质押相关数据
      autoDeposit: false,
      // 定时刷新相关
      autoRefreshTimer: null,
      autoRefreshInterval: 30000 // 30秒自动刷新一次
    }
  },
  computed: {
    ...mapGetters(['isLogin', 'accounts', 'userTheme'])
  },
  async mounted() {
    // 优先加载产品数据
    await this.fetchProducts();
    
    // 然后初始化其他数据
    this.initData();
    
    // 启动定时自动刷新
    this.startAutoRefresh();
    
    // 监听页面可见性变化
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  
  beforeUnmount() {
    // 清理定时器
    this.stopAutoRefresh();
    
    // 移除页面可见性监听
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  
  watch: {
    isLogin: {
      handler(newVal) {
        if (newVal) {
          this.fetchEasyEarnData();
        }
      },
      immediate: true
    },
    // 监听主题变化，强制更新样式
    userTheme: {
      handler(newTheme, oldTheme) {
        if (newTheme !== oldTheme) {
          // 主题切换时，强制触发样式更新
          this.$nextTick(() => {
            // 强制重新渲染，确保CSS变量正确应用
            this.$forceUpdate();
          });
        }
      },
      immediate: false
    }
  },

  methods: {
    // 获取盈亏颜色
    getProfitColor(profit) {
      if (profit === undefined || profit === null) return 'color-gray'
      const profitValue = parseFloat(profit)
      if (isNaN(profitValue)) return 'color-gray'
      if (profitValue > 0) {
        return 'color-green'
      } else if (profitValue < 0) {
        return 'color-red'
      } else {
        return 'color-gray'
      }
    },
    // 格式化盈亏显示
    formatProfit(profit) {
      if (profit === undefined || profit === null) return '--'
      const profitValue = parseFloat(profit)
      if (isNaN(profitValue)) return '--'
      if (profitValue > 0) {
        return `+${this.formatKlinePrice(profitValue)}`
      } else if (profitValue < 0) {
        return `-${this.formatKlinePrice(Math.abs(profitValue))}`
      } else {
        return '0.00'
      }
    },

    initData() {
      // 延迟一点时间确保登录状态已经初始化
      setTimeout(() => {
        if (this.isLogin) {
          this.fetchEasyEarnData();
        }
      }, 100);
    },
    toTerm() {
      this.$router.push("/term")
    },
    toDetail() {
      this.$router.push("/HomeView/investment/Term/detail")
    },
    goToLogin() {
      this.$router.push("/Login");
    },
    getCoinImage(symbol) {
      if (!symbol) return require('@/assets/images/coin/usdt.png');
      
      const coinImages = {
        'USDT': require('@/assets/images/coin/usdt.png'),
        'BTC': require('@/assets/images/coin/btc.png'),
        'ETH': require('@/assets/images/coin/eth.png'),
        'ADA': require('@/assets/images/coin/ada.png'),
        'DOGE': require('@/assets/images/coin/doge.png'),
        'LINK': require('@/assets/images/coin/link.png'),
        'BIB': require('@/assets/images/coin/bib.png')
      };
      
      // 为缺失的图标提供默认处理
      const upperSymbol = symbol.toUpperCase();
      if (coinImages[upperSymbol]) {
        return coinImages[upperSymbol];
      }
      
      // 对于 CBT 和 TRX，使用默认图标
      if (upperSymbol === 'CBT' || upperSymbol === 'TRX') {
        return require('@/assets/images/coin/usdt.png');
      }
      
      return require('@/assets/images/coin/usdt.png');
    },
    // 格式化数字显示
    formatNumber(value, decimals = 2) {
      if (value === null || value === undefined || value === '') {
        return '0.00';
      }
      
      const num = parseFloat(value);
      if (isNaN(num)) {
        return '0.00';
      }
      
      if (num === 0) {
        return '0.00';
      }
      
      // 如果是整数，显示整数
      if (Number.isInteger(num)) {
        return num.toString();
      }
      
      // 如果是小数，去除末尾的0
      const fixed = num.toFixed(decimals);
      return parseFloat(fixed).toString();
    },
    // 格式化百分比
    formatPercentage(value) {
      if (value === null || value === undefined || value === '') {
        return '0.00%';
      }
      
      const num = parseFloat(value);
      if (isNaN(num)) {
        return '0.00%';
      }
      
      if (num === 0) {
        return '0.00%';
      }
      
      // 去除末尾的0，保留有效数字
      const fixed = num.toFixed(2);
      const clean = parseFloat(fixed).toString();
      return clean + '%';
    },
    formatProductTerm(product) {
      const rawTerm = product && product.limit;
      if (rawTerm === null || rawTerm === undefined || String(rawTerm).trim() === '') {
        return '--';
      }

      const terms = String(rawTerm).split(',').map((term) => term.trim()).filter(Boolean);
      if (terms.length === 0) {
        return '--';
      }

      return terms.map((term) => term === '0'
        ? this.$t('investment.deposit_withdraw_freely')
        : `${term} ${this.$t('investment.days')}`).join(' / ');
    },
    formatProductAmount(value) {
      if (value === null || value === undefined || String(value).trim() === '') {
        return '--';
      }

      const normalized = String(value).trim();
      if (!/^\d+(?:\.\d+)?$/.test(normalized)) {
        return normalized;
      }

      const [integerPart, decimalPart = ''] = normalized.split('.');
      const whole = (integerPart.replace(/^0+(?=\d)/, '') || '0').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const fraction = decimalPart.replace(/0+$/, '');
      return fraction ? `${whole}.${fraction}` : whole;
    },
    formatProductAmountWithSymbol(value, symbol) {
      const amount = this.formatProductAmount(value);
      return amount === '--' ? '--' : `${amount}${symbol ? ` ${symbol}` : ''}`;
    },
    // 打开默认申购弹窗（选择第一个产品）
    async openDefaultDeposit() {
      if (!this.isLogin) {
        this.$message.warning(this.$t('common.not_logged_in_please_login'));
        this.$router.push('/Login');
        return;
      }
      
      // 如果产品数据还没有加载，先加载产品数据
      if (!this.products || this.products.length === 0) {
        console.log('产品数据未加载，开始加载产品数据...');
        
        // 显示加载提示
        const loadingMessage = this.$message.loading(this.$t('easy_earn.loading_product_data'), 0);
        
        try {
          await this.fetchProducts();
          loadingMessage.close();
        } catch (error) {
          loadingMessage.close();
          console.error('加载产品数据失败:', error);
          this.$message.error(this.$t('easy_earn.load_product_data_failed'));
          return;
        }
      }
      
      // 再次检查是否有可用产品
      if (!this.products || this.products.length === 0) {
        this.$message.warning(this.$t('easy_earn.no_subscription_products'));
        return;
      }
      
      // 选择第一个产品作为默认产品
      const defaultProduct = this.products[0];
      console.log('选择默认产品:', defaultProduct);
      
      // 验证产品数据完整性
      if (!defaultProduct.symbol && !defaultProduct.currency_symbol && !defaultProduct.currency) {
        console.error('默认产品数据不完整:', defaultProduct);
                  this.$message.error(this.$t('easy_earn.incomplete_product_data'));
        return;
      }
      
      // 调用原有的openDeposit方法
      await this.openDeposit(defaultProduct);
    },
    
    async openDeposit(product) {
      if (!this.isLogin) {
        this.$message.warning(this.$t('common.not_logged_in_please_login'));
        this.$router.push('/Login');
        return;
      }
      
      // 创建产品副本，避免修改原始数据
      this.selectedProduct = { ...product };
      this.visible = true;
      
      console.log("打开申购弹窗，产品:", this.selectedProduct);
      
      // 清空申购数量，让用户自己输入
      this.subscriptionAmount = "";
      
      // 重置自动质押状态
      this.autoDeposit = false;
      
      // 计算日期
      const now = new Date();
      this.submitDate = now.toISOString().split('T')[0]; // 今天作为买入提交日
      this.interestStartDate = new Date(now.getTime() + 24 * 60 * 60 * 1000).toISOString().split('T')[0]; // 明天作为起息日
      
      // 获取账户余额
      try {
        const response = await depositApi.getBalance(product.currency_id);
        
        if (response && response.data) {
          this.selectedProduct.balance = (response.data.balance || '0.00').toString();
        } else {
          this.selectedProduct.balance = '0.00';
        }
      } catch (error) {
        console.error("获取账户余额失败:", error);
        this.selectedProduct.balance = '0.00';
      }
      
      // 计算预计日息
      this.calculateEstimatedInterest();
    },
    calculateEstimatedInterest() {
      if (!this.selectedProduct || !this.subscriptionAmount) {
        this.estimatedDailyInterest = "0.00";
        return;
      }
      
      const amount = parseFloat(this.subscriptionAmount);
      const dayRate = parseFloat(this.selectedProduct.day_rate || 0);
      
      if (isNaN(amount) || isNaN(dayRate)) {
        this.estimatedDailyInterest = "0.00";
        return;
      }
      
      // 计算预计日息：申购数量 × 日息率
      const dailyInterest = amount * (dayRate / 100); // 日息率是百分比
      this.estimatedDailyInterest = dailyInterest.toFixed(4);
    },
    validateSubscriptionAmount() {
      if (!this.selectedProduct || !this.subscriptionAmount) {
        return false;
      }
      
      const amount = parseFloat(this.subscriptionAmount);
      const minAmount = parseFloat(this.selectedProduct.min || 1);
      const accountBalance = parseFloat(this.selectedProduct.balance || 0);
      
      if (isNaN(amount) || amount < minAmount) {
        this.$message.warning(this.$t('easy_earn.subscription_amount_below_min', { amount: this.formatNumber(minAmount, 2), symbol: this.selectedProduct.symbol || 'USDT' }));
        return false;
      }
      
      if (amount > accountBalance) {
        this.$message.warning(this.$t('easy_earn.subscription_amount_exceeds_balance', { balance: this.formatNumber(accountBalance, 2), symbol: this.selectedProduct.symbol || 'USDT' }));
        return false;
      }
      
      return true;
    },
    async confirmSubscription() {
      if (!this.validateSubscriptionAmount()) {
        return;
      }
      
      try {
        this.subscriptionLoading = true;
        const requestData = {
          did: this.selectedProduct.id || 1,  // 产品ID
          amount: this.subscriptionAmount,  // 申购金额
          auto: 1,  // 自动申购
          currency_id: this.selectedProduct.currency_id || 10,  // 币种ID
          approve: 0,  // 协议同意状态（固定为0）
          wallet_amount: 0,  // 钱包金额
          approve_address: ""  // 协议地址
        };
        
        const response = await depositApi.submitDeposit(requestData);
        
        if (response && response.code === 200) {
          // 记录申购前的余额
          const beforeBalance = this.selectedProduct.balance;
          
          this.$message.success(this.$t('easy_earn.subscription_success'));
          this.visible = false;
          
          // 无痕自动刷新所有数据
          this.silentRefreshAllData();
        } else {
          console.error("申购失败，响应:", response);
          const errorMessage = response?.message || response?.msg || this.$t('easy_earn.subscription_failed_retry');
          this.$message.error(errorMessage);
        }
      } catch (error) {
        console.error("申购失败，错误详情:", error);
        console.error("错误响应:", error.response);
        console.error("错误状态:", error.response ? error.response.status : '无响应');
        console.error("错误数据:", error.response?.data);
        
        let errorMessage = this.$t('easy_earn.subscription_failed_retry');
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || error.response.data.msg || errorMessage;
        }
        
        this.$message.error(errorMessage);
      } finally {
        this.subscriptionLoading = false;
      }
    },
    
    async refreshDepositBalance() {
      try {
        if (this.selectedProduct && this.selectedProduct.currency_id) {
          const response = await depositApi.getBalance(this.selectedProduct.currency_id);
          
          if (response && response.data) {
            this.selectedProduct.balance = (response.data.balance || '0.00').toString();
          }
        }
      } catch (error) {
        console.error("刷新申购余额失败:", error);
        // 不显示错误消息，避免影响用户体验
      }
    },
    
    // 无痕自动刷新所有数据
    async silentRefreshAllData() {
      try {
        console.log('开始无痕自动刷新数据...');
        
        // 并行执行所有刷新操作，提高效率
        const refreshPromises = [
          // 刷新活币宝产品数据
          this.fetchEasyEarnData().catch(error => {
            console.error('刷新活币宝数据失败:', error);
          }),
          
          // 刷新账户余额
          this.refreshAccountBalance().catch(error => {
            console.error('刷新账户余额失败:', error);
          }),
          
          // 刷新当前选中产品的余额
          this.refreshDepositBalance().catch(error => {
            console.error('刷新产品余额失败:', error);
          })
        ];
        
        // 等待所有刷新操作完成
        await Promise.allSettled(refreshPromises);
        
        console.log('无痕自动刷新数据完成');
        
        // 延迟再次刷新活币宝数据，确保数据完全更新
        setTimeout(() => {
          this.fetchEasyEarnData().catch(error => {
            console.error('延迟刷新活币宝数据失败:', error);
          });
        }, 1000);
        
      } catch (error) {
        console.error('无痕自动刷新数据失败:', error);
        // 静默处理错误，不影响用户体验
      }
    },
    
    // 启动定时自动刷新
    startAutoRefresh() {
      // 清除可能存在的定时器
      this.stopAutoRefresh();
      
      // 启动新的定时器
      this.autoRefreshTimer = setInterval(() => {
        // 只有在用户已登录且页面可见时才刷新
        if (this.isLogin && document.visibilityState === 'visible') {
          console.log('定时自动刷新数据...');
          this.silentRefreshAllData();
        }
      }, this.autoRefreshInterval);
      
      console.log('定时自动刷新已启动，间隔:', this.autoRefreshInterval / 1000, '秒');
    },
    
    // 停止定时自动刷新
    stopAutoRefresh() {
      if (this.autoRefreshTimer) {
        clearInterval(this.autoRefreshTimer);
        this.autoRefreshTimer = null;
        console.log('定时自动刷新已停止');
      }
    },
    
    // 重新启动定时自动刷新
    restartAutoRefresh() {
      this.stopAutoRefresh();
      this.startAutoRefresh();
    },
    
    // 处理页面可见性变化
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        // 页面变为可见时，立即刷新一次数据
        if (this.isLogin) {
          console.log('页面重新可见，立即刷新数据');
          this.silentRefreshAllData();
        }
      }
    },
    
    // 设置最大申购金额
    setMaxAmount() {
      if (!this.selectedProduct) {
        this.$message.warning(this.$t('easy_earn.please_select_product'));
        return;
      }
      
      if (!this.selectedProduct.balance) {
        this.$message.warning(this.$t('easy_earn.cannot_get_balance'));
        return;
      }
      
      const maxAmount = parseFloat(this.selectedProduct.balance);
      if (isNaN(maxAmount) || maxAmount <= 0) {
        this.$message.warning(this.$t('easy_earn.insufficient_balance'));
        return;
      }
      
      // 检查最低申购限制
      const minAmount = parseFloat(this.selectedProduct.min || 1);
      if (maxAmount < minAmount) {
        this.$message.warning(this.$t('easy_earn.insufficient_balance_for_min', { amount: this.formatNumber(minAmount, 2), symbol: this.selectedProduct.symbol || 'USDT' }));
        return;
      }
      
      // 设置最大申购金额，保留4位小数
      this.subscriptionAmount = maxAmount.toFixed(4);
      
      // 重新计算预计日息
      this.calculateEstimatedInterest();
      
      console.log('设置最大申购金额:', {
        balance: this.selectedProduct.balance,
        maxAmount: this.subscriptionAmount,
        symbol: this.selectedProduct.symbol
      });
    },
    
    // 处理自动质押开关变化
    async handleAutoDepositChange(checked) {
      if (!this.selectedProduct) {
        this.$message.warning(this.$t('easy_earn.please_select_product'));
        this.autoDeposit = false; // 重置开关状态
        return;
      }
      
      try {
        // 根据币种确定did
        let did = 1; // 默认USDT
        
        if (this.selectedProduct && this.selectedProduct.symbol) {
          const symbol = this.selectedProduct.symbol.toUpperCase();
          if (symbol === 'USDT') {
            did = 1;
          } else if (symbol === 'BTC') {
            did = 2;
          } else if (symbol === 'ETH') {
            did = 3;
          } else if (symbol === 'CBT') {
            did = 4;
          } else if (symbol === 'TRX') {
            did = 5;
          }
        }
        
        console.log('自动质押开关变化:', {
          checked: checked,
          symbol: this.selectedProduct.symbol,
          did: did
        });
        
        const response = await depositApi.changeAuto(did);
        
        if (response && response.code === 200) {
          this.$message.success(checked ? this.$t('easy_earn.auto_staking_enabled') : this.$t('easy_earn.auto_staking_disabled'));
          console.log('自动质押设置成功:', response);
          
          // 无痕自动刷新数据
          this.silentRefreshAllData();
        } else {
          this.$message.error(this.$t('easy_earn.setting_failed_retry'));
          this.autoDeposit = !checked; // 恢复原状态
        }
      } catch (error) {
        console.error('自动质押设置失败:', error);
        this.$message.error(this.$t('easy_earn.setting_failed_retry'));
        this.autoDeposit = !checked; // 恢复原状态
      }
    },
    
    async refreshAccountBalance() {
      try {
        const response = await commonApi.getAccountCurrency();
        if (response && response.code === 200 && response.data) {
          this.$store.commit('setAccounts', this.processAccountData(response.data));
        }
      } catch (error) {
        console.error("刷新账户余额失败:", error);
      }
    },
    
    processAccountData(data) {
      // 如果data直接包含trade_balance字段，直接使用
      if (data && typeof data === 'object' && data.trade_balance !== undefined) {
        return {
          legal_balance: data.legal_balance || "0.00",
          balance: data.balance || "0.00",
          lock_balance: data.lock_balance || "0.00",
          trade_balance: data.trade_balance || "0.00",
          lock_trade: data.lock_trade || "0.00",
          contract_balance: data.contract_balance || "0.00",
          lock_contract: data.lock_contract || "0.00",
          future_balance: data.future_balance || "0.00",
          lock_future: data.lock_future || "0.00",
          finance_balance: data.finance_balance || "0.00",
          lock_finance: data.lock_finance || "0.00"
        };
      }
      
      // 如果data是数组，查找USDT的余额
      if (Array.isArray(data)) {
        const accounts = {
          legal_balance: "0.00",
          balance: "0.00",
          lock_balance: "0.00",
          trade_balance: "0.00",
          lock_trade: "0.00",
          contract_balance: "0.00",
          lock_contract: "0.00",
          future_balance: "0.00",
          lock_future: "0.00",
          finance_balance: "0.00",
          lock_finance: "0.00"
        };
        
        // 查找USDT账户 - 通过币种ID 10
        const usdtAccount = data.find(item => {
          const currencyId = item.currency_id || item.id;
          return currencyId === 10 || currencyId === '10';
        });
        
        if (usdtAccount) {
          accounts.trade_balance = usdtAccount.trade_balance || "0.00";
          accounts.lock_trade = usdtAccount.lock_trade || "0.00";
        }
        
        return accounts;
      }
      
      return {
        legal_balance: "0.00",
        balance: "0.00",
        lock_balance: "0.00",
        trade_balance: "0.00",
        lock_trade: "0.00",
        contract_balance: "0.00",
        lock_contract: "0.00",
        future_balance: "0.00",
        lock_future: "0.00",
        finance_balance: "0.00",
        lock_finance: "0.00"
      };
    },
    async confirmRedeem() {
      // 手动赎回已关闭，产品只能等待期限结束后结算。
      return;
      /*
      // 完全安全的赎回方法
      try {
        // 设置加载状态
        if (typeof this.redeemLoading !== 'undefined') {
          this.redeemLoading = true;
        }
        
        // 验证selectedProduct是否存在
        if (!this.selectedProduct || !this.selectedProduct.symbol) {
          this.$message.error(this.$t('investment.invalid_product_information'));
          return;
        }
        
        // 验证redeemType是否存在
        if (typeof this.redeemType === 'undefined') {
          this.redeemType = 1; // 默认T+1到账
        }
        
        // 使用正确的赎回接口参数 - 根据币种使用固定ID
        let productId = 25; // 默认USDT
        
        if (this.selectedProduct && this.selectedProduct.symbol) {
          const symbol = this.selectedProduct.symbol.toUpperCase();
          if (symbol === 'BTC') {
            productId = 27;
          } else if (symbol === 'USDT') {
            productId = 25;
          } else if (symbol === 'ETH') {
            productId = 28;
          } else if (symbol === 'CBT') {
            productId = 29;
          } else if (symbol === 'TRX') {
            productId = 30;
          }
          // 可以根据需要添加更多币种
        }
        
        const requestData = {
          did: productId,
          type: this.redeemType
        };
        
        console.log('赎回请求数据:', {
          symbol: this.selectedProduct.symbol,
          productId: productId,
          redeemType: this.redeemType,
          requestData: requestData
        });
        
        // 安全调用API
        let response = null;
        try {
          response = await depositApi.redeem(requestData);
          console.log('赎回响应:', response);
        } catch (apiError) {
          console.error('API调用失败:', apiError);
          throw apiError;
        }
        
        // 安全处理响应
        if (response && response.code === 200) {
          this.$message.success(this.$t('easy_earn.redemption_submitted_success'));
          
          // 安全关闭弹窗
          if (typeof this.redeemVisible !== 'undefined') {
            this.redeemVisible = false;
          }
          
          // 无痕自动刷新所有数据
          this.silentRefreshAllData();
        } else {
          const errorMessage = response && response.message ? response.message : 
                             response && response.msg ? response.msg : this.$t('easy_earn.redemption_failed_retry');
          this.$message.error(errorMessage);
        }
      } catch (error) {
        console.error('赎回失败:', error);
        
        let errorMessage = this.$t('easy_earn.redemption_failed_retry');
        if (error && error.response && error.response.data) {
          errorMessage = error.response.data.message || error.response.data.msg || errorMessage;
        } else if (error && error.message) {
          errorMessage = error.message;
        }
        
        console.error('最终错误消息:', errorMessage);
        this.$message.error(errorMessage);
      } finally {
        // 安全设置加载状态
        if (typeof this.redeemLoading !== 'undefined') {
          this.redeemLoading = false;
        }
      }
      */
    },


    async fetchProducts() {
      try {
        this.loading = true;
        console.log("开始获取产品数据...");
        
        const response = await depositApi.getItems();
        console.log("=== 活币宝API响应 ===");
        console.log("完整响应:", response);
        
        if (response && response.data) {
          console.log("response.data:", response.data);
          console.log("response.data类型:", typeof response.data);
          console.log("response.data长度:", Array.isArray(response.data) ? response.data.length : '不是数组');
          
          if (Array.isArray(response.data) && response.data.length > 0) {
            this.products = response.data;
            console.log("设置的产品数据:", this.products);
            
            // 详细检查第一个产品
            if (this.products[0]) {
              console.log("=== 第一个产品详情 ===");
              console.log("完整对象:", this.products[0]);
              console.log("所有键:", Object.keys(this.products[0]));
              console.log("symbol:", this.products[0].symbol);
              console.log("year_rate:", this.products[0].year_rate);
              console.log("day_rate:", this.products[0].day_rate);
              console.log("limit:", this.products[0].limit);
              console.log("limit类型:", typeof this.products[0].limit);
            }
          } else {
            console.log("API返回数据为空或不是数组");
            this.products = [];
          }
        } else {
          console.log("API响应格式不正确");
          this.products = [];
        }
      } catch (error) {
        console.error("获取活币宝产品数据失败:", error);
        this.products = [];
        
        // 如果是网络错误，尝试重试
        if (error.message && error.message.includes('Network')) {
          console.log("网络错误，3秒后重试产品数据...");
          setTimeout(() => {
            this.fetchProducts();
          }, 3000);
        }
      } finally {
        this.loading = false;
      }
    },
    async fetchEasyEarnData() {
      try {
        console.log("开始获取活币宝数据，登录状态:", this.isLogin);
        
        if (!this.isLogin) {
          console.log("用户未登录，跳过数据获取");
          return;
        }
        
        const response = await depositApi.getProfit();
        console.log("活币宝收益数据:", response);
        
        if (response && response.data) {
          // 根据API返回的字段名设置数据，确保转换为字符串
          this.totalBalance = (response.data.total || "0.00").toString();
          this.yesterdayEarnings = (response.data.today || "0.00").toString();
          this.totalEarnings = (response.data.profit || "0.00").toString();
          
          console.log("设置的数据:", {
            totalBalance: this.totalBalance,
            yesterdayEarnings: this.yesterdayEarnings,
            totalEarnings: this.totalEarnings
          });
        } else {
          console.log("API返回数据为空，使用默认数据");
          this.totalBalance = "0.00";
          this.yesterdayEarnings = "0.00";
          this.totalEarnings = "0.00";
        }
      } catch (error) {
        console.error("获取活币宝数据失败:", error);
        
        // 如果API失败，使用默认数据
        this.totalBalance = "0.00";
        this.yesterdayEarnings = "0.00";
        this.totalEarnings = "0.00";
        
        // 如果是网络错误，尝试重试
        if (error.message && error.message.includes('Network')) {
          console.log("网络错误，3秒后重试...");
          setTimeout(() => {
            this.fetchEasyEarnData();
          }, 3000);
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./easyEarn.scss";
</style>
